// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_option_is = /** @type {(inputs: { option: NonNullable<unknown>, value: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.option}: ${i.value}`
};

const el_option_is = /** @type {(inputs: { option: NonNullable<unknown>, value: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.option}: ${i.value}`
};

const ru_option_is = /** @type {(inputs: { option: NonNullable<unknown>, value: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.option}: ${i.value}`
};

const he_option_is = /** @type {(inputs: { option: NonNullable<unknown>, value: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.option}: ${i.value}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ option: NonNullable<unknown>, value: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const option_is = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.option_is(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("option_is", locale)
	if (locale === "en") return en_option_is(inputs)
	if (locale === "el") return el_option_is(inputs)
	if (locale === "ru") return ru_option_is(inputs)
	if (locale === "he") return he_option_is(inputs)
	return "option_is"
};